import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ContentHeader from "@/components/ContentHeader";
import InfinityScrollList from "@/components/InfinityScrollList";
import Loading from "@/components/Loading";
import { useCopyrights, usePagination } from "@/hooks";
import styles from "@/styles/List.module.scss";
import classnames from "classnames";
import { cloneElement, createElement, memo, useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function List(_ref) {
  var _items$data, _items$data2, _classnames;

  var header = _ref.header,
      itemComponent = _ref.itemComponent,
      limit = _ref.limit,
      maxLength = _ref.maxLength,
      loadMore = _ref.loadMore,
      loading = _ref.loading,
      error = _ref.error,
      fetchMore = _ref.fetchMore,
      variables = _ref.variables,
      items = _ref.items,
      noContent = _ref.noContent,
      viewTypeClassName = _ref.viewTypeClassName;

  if (error) {// TODO: error view
  }

  var _useCopyrights = useCopyrights(),
      setCopyrights = _useCopyrights.setCopyrights;

  var _usePagination = usePagination({
    limit: limit !== null && limit !== void 0 ? limit : variables === null || variables === void 0 ? void 0 : variables.limit,
    maxLength: maxLength,
    loadMore: loadMore,
    fetchMore: fetchMore,
    items: items
  }),
      enableLoadMore = _usePagination.enableLoadMore,
      fetchMoreCallback = _usePagination.fetchMoreCallback;

  var dataLength = (items === null || items === void 0 ? void 0 : (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) || 0;
  useEffect(function () {
    if (items && items.data.length > 0) {
      var copyrights = items.data.map(function (item) {
        return item.copyright;
      });
      setCopyrights(copyrights);
    }
  }, [dataLength]);

  if (!loading && (items === null || items === void 0 ? void 0 : (_items$data2 = items.data) === null || _items$data2 === void 0 ? void 0 : _items$data2.length) === 0) {
    if (noContent) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/cloneElement(noContent)
      });
    } else {
      return null;
    }
  }

  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.grid, viewTypeClassName === "grid"), _defineProperty(_classnames, styles.list, viewTypeClassName === "list"), _defineProperty(_classnames, styles.pickuplist, viewTypeClassName === "pickuplist"), _defineProperty(_classnames, styles.channelsList, viewTypeClassName === "channelsList"), _classnames)),
    children: [header && /*#__PURE__*/_jsx(ContentHeader, _objectSpread({
      viewTypeClassName: viewTypeClassName
    }, header)), loading && dataLength === 0 && /*#__PURE__*/_jsx("div", {
      className: styles.loading,
      children: /*#__PURE__*/_jsx(Loading, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: /*#__PURE__*/_jsx(InfinityScrollList, {
        loadMore: enableLoadMore,
        fetchMore: fetchMoreCallback,
        children: items && items.data.map(function (item, i) {
          return /*#__PURE__*/_jsx(ListItem, {
            itemComponent: itemComponent,
            item: item
          }, "list-".concat(i));
        })
      })
    })]
  });
}
var ListItem = /*#__PURE__*/memo(function (_ref2) {
  var itemComponent = _ref2.itemComponent,
      item = _ref2.item;
  return /*#__PURE__*/_jsx("div", {
    className: styles.listItem,
    children: /*#__PURE__*/createElement(itemComponent, {
      item: item
    })
  });
});